import { FC } from 'react'
import { Box, Typography } from '@mui/material'

/* Utils */
import { accountSettingsSelector } from '../../../../../store/user/userSlice'
import { useAppSelector } from '../../../../../store/hooks'

/* Components */
import { AccountWrapper, CompanyHeader, CompanyInfoSection, InfoRow, EditButton } from './AccountInformation.styles'

interface Props {
  onEditClick: () => void
  canEdit: boolean
}

const AccountInformation: FC<Props> = ({ onEditClick, canEdit }) => {
  const account = useAppSelector(accountSettingsSelector)

  return (
    <AccountWrapper>
      <CompanyHeader>
        <Box className="logo-wrapper">
          <img
            src={`${account?.logo ? `${process.env.REACT_APP_LOGO_HOST}${account.logo}` : '/dashboard-logo.svg'}`}
            alt="company logo"
          />
        </Box>
        <Typography className="company-name">{account?.name}</Typography>
      </CompanyHeader>

      <CompanyInfoSection>
        <Typography className="section-title">Company Information</Typography>

        <InfoRow>
          <Box className="icon-wrapper">
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M2.25 5.0625C2.25 4.0305 3.0930 3.1875 4.125 3.1875H13.875C14.907 3.1875 15.75 4.0305 15.75 5.0625V12.9375C15.75 13.9695 14.907 14.8125 13.875 14.8125H4.125C3.0930 14.8125 2.25 13.9695 2.25 12.9375V5.0625Z"
                stroke="#A88CA4"
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M5.8125 11.0625H8.4375M5.8125 8.4375H12.1875M5.8125 5.8125H6.9375"
                stroke="#A88CA4"
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </Box>
          <Box className="info-content">
            <Typography className="info-label">Company Name</Typography>
            <Typography className="info-value">{account?.name}</Typography>
          </Box>
        </InfoRow>

        <InfoRow>
          <Box className="icon-wrapper">
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M12.75 5.25V3.9375C12.75 3.41973 12.3303 3 11.8125 3H6.1875C5.66973 3 5.25 3.41973 5.25 3.9375V5.25M12.75 5.25H5.25M12.75 5.25H15.1875C15.7053 5.25 16.125 5.66973 16.125 6.1875V14.0625C16.125 14.5803 15.7053 15 15.1875 15H2.8125C2.29473 15 1.875 14.5803 1.875 14.0625V6.1875C1.875 5.66973 2.29473 5.25 2.8125 5.25H5.25"
                stroke="#A88CA4"
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </Box>
          <Box className="info-content">
            <Typography className="info-label">Industry</Typography>
            <Typography className="info-value">{account?.industry}</Typography>
          </Box>
        </InfoRow>

        <InfoRow>
          <Box className="icon-wrapper">
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M9 4.5V9L12 10.5M15.75 9C15.75 12.7279 12.7279 15.75 9 15.75C5.27208 15.75 2.25 12.7279 2.25 9C2.25 5.27208 5.27208 2.25 9 2.25C12.7279 2.25 15.75 5.27208 15.75 9Z"
                stroke="#A88CA4"
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </Box>
          <Box className="info-content">
            <Typography className="info-label">Timezone</Typography>
            <Typography className="info-value">{account?.timeZone}</Typography>
          </Box>
        </InfoRow>
      </CompanyInfoSection>

      <EditButton onClick={onEditClick} disabled={!canEdit}>
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M11.3333 2.00004C11.5084 1.82494 11.7163 1.68605 11.9451 1.59129C12.1739 1.49653 12.4191 1.44775 12.6667 1.44775C12.9143 1.44775 13.1595 1.49653 13.3883 1.59129C13.617 1.68605 13.8249 1.82494 14 2.00004C14.1751 2.17513 14.314 2.383 14.4088 2.61178C14.5035 2.84055 14.5523 3.08575 14.5523 3.33337C14.5523 3.58099 14.5035 3.82619 14.4088 4.05497C14.314 4.28374 14.1751 4.49161 14 4.6667L5.00001 13.6667L1.33334 14.6667L2.33334 11L11.3333 2.00004Z"
            stroke="#FFA9FC"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        <Typography className="button-text">Edit</Typography>
      </EditButton>
    </AccountWrapper>
  )
}

export default AccountInformation
